export default __webpack_public_path__ + "static/media/icon-sad-face.dab4da52.svg";